import axios from '../../axios'

/*
 * 院校统校考类型信息管理接口
 */

// 创建院校统校考类型信息
export const addTxExamType = (data) => {
    return axios({
        url: '/api/data/wish/school/exam/type',
        method: 'POST',
        data
    })
}

// 获取院校统校考类型详情
export const getTxExamType = (data) => {
    return axios({
        url: '/api/data/wish/school/exam/type/info',
        method: 'GET',
        data
    })
}

// 修改院校统校考类型信息
export const editTxExamType = (data) => {
    return axios({
        url: '/api/data/wish/school/exam/type',
        method: 'PUT',
        data
    })
}

// 删除院校统校考类型信息
export const deleteTxExamType = (data) => {
    return axios({
        url: '/api/data/wish/school/exam/type',
        method: 'DELETE',
        data
    })
}

// 根据信息综合搜索院校统校考类型信息列表
export const searchTxExamTypeList = (data) => {
    return axios({
        url: '/api/data/wish/school/exam/type',
        method: 'get',
        data
    })
}

// 院校统校考类型导入
export const importTxExamType = (data) => {
    return axios({
        url: '/api/data/wish/school/exam/type/import',
        method: 'POST',
        data
    })
}

// 院校统校考类型导出
export const exportTxExamType = (data) => {
    return axios({
        url: '/api/data/wish/school/exam/type/export',
        method: 'POST',
        data
    })
}

// 院校统校考类型批量更新
export const updateTxExamType = (data) => {
    return axios({
        url: '/api/data/wish/school/exam/type/batch/update',
        method: 'POST',
        data
    })
}

// 院校统校考类型批量删除
export const queryDelTxExamType = (data) => {
    return axios({
        url: '/api/data/wish/school/exam/type/batch/delete',
        method: 'POST',
        data
    })
}

// 院校统校考类型校验院校类型
export const checkSchoolType = (data) => {
    return axios({
        url: '/api/data/wish/school/exam/type/check',
        method: 'POST',
        data
    })
}

// 校考日历下面的
/*
 * 校考日历-院校统校考类型信息管理接口校考日历-院校统校考类型
 */

// 创建校考日历-院校统校考类型信息
export const addSchTxExamType = (data) => {
    return axios({
        url: '/api/data/wish/school/sch/exam/type',
        method: 'POST',
        data
    })
}

// 获取校考日历-院校统校考类型详情
export const getSchTxExamType = (data) => {
    return axios({
        url: '/api/data/wish/school/sch/exam/type/info',
        method: 'GET',
        data
    })
}

// 修改校考日历-院校统校考类型信息
export const editSchTxExamType = (data) => {
    return axios({
        url: '/api/data/wish/school/sch/exam/type',
        method: 'PUT',
        data
    })
}

// 删除校考日历-院校统校考类型信息
export const deleteSchTxExamType = (data) => {
    return axios({
        url: '/api/data/wish/school/sch/exam/type',
        method: 'DELETE',
        data
    })
}

// 根据信息综合搜索校考日历-院校统校考类型信息列表
export const searchSchTxExamTypeList = (data) => {
    return axios({
        url: '/api/data/wish/school/sch/exam/type',
        method: 'get',
        data
    })
}

// 校考日历-院校统校考类型导入
export const importSchTxExamType = (data) => {
    return axios({
        url: '/api/data/wish/school/sch/exam/type/import',
        method: 'POST',
        data
    })
}

// 校考日历-院校统校考类型导出
export const exportSchTxExamType = (data) => {
    return axios({
        url: '/api/data/wish/school/sch/exam/type/export',
        method: 'POST',
        data
    })
}

// 校考日历-院校统校考类型批量更新
export const updateSchTxExamType = (data) => {
    return axios({
        url: '/api/data/wish/school/sch/exam/type/batch/update',
        method: 'POST',
        data
    })
}

// 校考日历-院校统校考类型批量删除
export const queryDelSchTxExamType = (data) => {
    return axios({
        url: '/api/data/wish/school/sch/exam/type/batch/delete',
        method: 'POST',
        data
    })
}



// WEBPACK FOOTER //
// ./src/http/moudules/dataManage/txexamtype.js